import React from "react";
import { Button } from "./ui/button";
import { Link, useLocation } from "react-router-dom";

function Footer() {
  const { pathname } = useLocation();
  const isEnglish = pathname.startsWith("/en");

  const privacyTo = isEnglish ? "/en/privacystatement" : "/nl/privacystatement";
  const colophonTo = isEnglish ? "/en/colophon" : "/nl/colofon";
  const colophonLabel = isEnglish ? "Colophon" : "Colofon";

  return (
    <footer className="py-0 px-0 font-gotham rounded-3xl m-2">
      <div className="flex flex-col md:flex-row justify-between items-center gap-0 px-4">
        {/* External links (same text) */}
        <div className="flex flex-wrap justify-center gap-2">
          <a
            href="https://www.vangoghmuseum.nl"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            <Button
              variant="link"
              className="hover:text-gray-700 hover:no-underline focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black text-sm"
            >
              Van Gogh Museum
            </Button>
          </a>

          <a
            href="https://www.samensterkmetwerk.nl"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            <Button
              variant="link"
              className="hover:text-gray-700 hover:no-underline focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black text-sm"
            >
              Samen Sterk met Werk
            </Button>
          </a>
        </div>

        {/* Internal links (route switches by language; labels stay the same) */}
        <div className="flex flex-wrap justify-center gap-2">
          <Button
            asChild
            variant="link"
            className="hover:text-gray-700 hover:no-underline focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black text-sm"
          >
            <Link to={privacyTo}>Privacy Statement</Link>
          </Button>

          <Button
            asChild
            variant="link"
            className="hover:text-gray-700 hover:no-underline focus:outline-none focus:ring-0 focus-visible:outline-none bg-transparent text-black text-sm"
          >
            <Link to={colophonTo}>{colophonLabel}</Link>
          </Button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
